<template>
  <div class="video" :class="`-mode-${$root.mode}`">
    <figure class="embed-responsive embed-responsive-16by9">
      <div
        class="embed-responsive-item poster"
        :style="{ 'background-image': `url(${item.thumbnail || posterFrame})` }"
      ></div>
      <transition name="fade">
        <div v-if="!active" @click="presentModal()" class="play-button"></div>
      </transition>
    </figure>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      posterFrame: null,
      active: false,
    };
  },
  created() {
    axios
      .get(
        `//${location.hostname}/wp-json/resmed/v1/brightcove-thumbnail/${this.item.video_id}`
      )
      .then((response) => {
        this.posterFrame = response.data.poster.src;
      });

    bus.$on("overlay:active:boolean", (active, player, id) => {
      if (player === this.item.player && id === this.item.video_id) {
        this.active = active;
      }
    });
  },
  methods: {
    presentModal() {
      bus.$emit("overlay:active", {
        player: this.item.player,
        id: this.item.video_id,
        active: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/abstracts/path";
@import "../../../../css/abstracts/colors";

.video {
  width: 100%;
  height: auto;
  padding: 0.75rem;

  figure {
    border-radius: 4px;
    box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    cursor: pointer;

    .poster {
      background-size: cover;
      background-color: $cc-resmed-black;
    }

    .play-button {
      content: "";
      position: absolute;
      width: 100%;
      padding-top: 56.25%;
      z-index: 3;
      top: 0;
      background-image: url("#{$assets}/images/icon-play-button.svg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 4rem 4rem;
      opacity: 0.925;
      transition: opacity 0.5s ease;
    }

    &:hover {
      .play-button {
        opacity: 1;
      }
    }
  }

  &.-mode-xs,
  &.-mode-sm {
    figure {
      box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    }
  }
}
</style>